module.exports = __webpack_public_path__ + "static/img/__9291.9f08092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9291.jpg
// module id = Y2XU
// module chunks = 0